import agentSshTemplateUrl from './agent-ssh.template.html';
import { GUDHUB_SETTINGS } from '../../../config.js';
import { request } from '../agents.request.js';

angular.module('agentsTableModule')

.directive('agentSshTab', [function () {
    return {
        restrict: 'E',
        scope: {
            agent: '='
        },
        controller: ['$scope', '$timeout', 'localizationService', function ($scope, $timeout, localizationService) {
            const dictionary = localizationService.getDictionary('account_settings');
            $scope.translate = (word) => localizationService.translate(word, dictionary);

            $scope.copied = false;

            $scope.copyKey = function () {
                if (!$scope.agent.rsa_public_key) return;
                navigator.clipboard.writeText($scope.agent.rsa_public_key).then(function () {
                    $scope.copied = true;
                    $scope.$applyAsync();
                    $timeout(function () {
                        $scope.copied = false;
                    }, 2000);
                });
            };

            $scope.regenerating = false;

            $scope.regenerateKey = async function () {
                if ($scope.regenerating || !$scope.agent._id) return;
                $scope.regenerating = true;
                $scope.$applyAsync();
                try {
                    const result = await request('/regenerate-key', { agent_id: $scope.agent._id });
                    $scope.agent.rsa_public_key = result.rsa_public_key;
                } catch (err) {
                    console.error('Failed to regenerate RSA key:', err);
                } finally {
                    $scope.regenerating = false;
                    $scope.$applyAsync();
                }
            };

            $scope.openTerminal = async function () {
                if (!$scope.agent._id) return;
                const token = await gudhub.getToken();
                const url = GUDHUB_SETTINGS.agents_server_url + '/agents/' + $scope.agent._id + '/terminal/ui?access_token=' + encodeURIComponent(token);
                window.open(url, 'TerminalWin', 'width=800,height=600,left=100,top=200,resizable=yes,scrollbars=yes');
            };
        }],
        templateUrl: agentSshTemplateUrl
    };
}]);
